// Simple cache for Quran API responses
class QuranCache {
  constructor() {
    this.cache = new Map();
    this.verseCache = new Map();
    this.maxSize = 100; // Max cached items
  }

  set(key, value) {
    // Don't cache null/undefined
    if (value === null || value === undefined) return;

    // Implement simple LRU
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }

    this.cache.set(key, {
      value,
      timestamp: Date.now()
    });
  }

  get(key) {
    const item = this.cache.get(key);
    if (!item) return null;

    // Return if less than 5 minutes old
    const FIVE_MINUTES = 5 * 60 * 1000;
    if (Date.now() - item.timestamp < FIVE_MINUTES) {
      return item.value;
    }

    // Delete expired
    this.cache.delete(key);
    return null;
  }

  setVerse(surahNumber, ayahNumber, verse) {
    const key = `${surahNumber}:${ayahNumber}`;
    this.verseCache.set(key, {
      value: verse,
      timestamp: Date.now()
    });
  }

  getVerse(surahNumber, ayahNumber) {
    const key = `${surahNumber}:${ayahNumber}`;
    const item = this.verseCache.get(key);
    if (!item) return null;

    // Verses never expire during session
    return item.value;
  }

  clear() {
    this.cache.clear();
    this.verseCache.clear();
  }
}

export const quranCache = new QuranCache();
